import React from 'react';

const IntroBasic = ({intro}) => (
  <div className="mt4 mb4 mt6-l mb6-l pl4 pr4 tl tc-l">
    <div className="f3 f-intro-l black measure center lh-copy">{intro.text}</div>
  </div>
);

export default IntroBasic;
